export const MIN_PRICE_RANGE_VALUE = 15;
